import { MissionData } from '../blocks/mission'
import template from './templates/RJS11.rbxl'
import thumbnail1 from './thumbnails/RJS11/Ball.png'
import thumbnail2 from './thumbnails/RJS11/Switch.png'
import thumbnail3 from './thumbnails/RJS11/SpawnLocation.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①ボール',
      sound: true,
      thumbnail: thumbnail1,
    },
    {
      name: '②スイッチ',
      sound: true,
      thumbnail: thumbnail2,
    },
    {
      name: '③スタートちてん',
      thumbnail: thumbnail3,
    },
  ],
}

export default mission
